import { createContext } from 'react';

const EditorPropsContext = createContext(null);

export default EditorPropsContext;
